var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cr_error"},[_c('img',{staticClass:"cr_error-icon",attrs:{"src":require("./../../assets/images/components/utils/cross.svg"),"alt":""}}),_c('div',{staticClass:"cr_error-text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }